import klineStyle from '../echartsOption/klineStyle';

/**
 * 定义净流量类
 */
class NETFLOW {
    /**
     * 净流量类构造函数
     * @param {Array<Number>} vols 净流量序列
     */
    constructor(vols) {
        this.datas = vols;

        this.seriesOptions = {
            name: 'NetFlow',
            type: 'bar',
            xAxisIndex: 2,
            yAxisIndex: 2,
            data: [],
            itemStyle: {
                normal: {
                    color(params) {
                        var colorList;
                        if (params.value > 0) {
                            colorList = klineStyle.lineColor.color;
                        } else {
                            colorList = klineStyle.lineColor.color0;
                        }
                        return colorList;
                    }
                }
            }
        };
    }

    /**
     * 因为数据缺失，所以需要按照K线的数据量补充
     * @param {Array<String>} times 日期时间序列
     */
    calculate(times) {
        this.datas = times.map(datetime => {
            let netCount = null;
            this.datas.some(data => {
                if (data.datetime.toString() === datetime) {
                    netCount = data.netCount;
                    return true;
                }
                return false;
            });
            return netCount;
        });
    }

    /**
     * 生成Series选项
     * @returns {Object} 返回生成的echarts的option对象
     */
    generateSeriesOption() {
        this.seriesOptions.data = this.datas;
        return this.seriesOptions;
    }
}

export default NETFLOW;



// WEBPACK FOOTER //
// ./src/controller/series/NETFLOW.js